<template lang="pug">
v-layout(row justify-center)
  v-dialog(data-cy="add-modal.dialog" :value="value" persistent max-width="620")
    v-card
      title-bar(data-cy="add-modal.title" dark) {{ getTitle }}
      v-card-text
        span Help other LionDesk Users and share your campaigns!
        v-form(@submit.prevent='save()' v-model="valid")
            v-select(
              v-model='shareTypeId'
              :items='dropdownPublicTypeItems'
              item-text="text"
              item-value="value"
              label="Publish to"
              required
            )
            v-text-field(
              v-if='shareTypeId === SHARE_TYPES.PRIVATE'
              v-model="accessCode"
              placeholder="Add Code"
              label="Code"
              data-cy="add-modal.name"
              autofocus
              required
            )
            v-combobox(
              required
              chips
              deletable-chips
              append-icon
              multiple
              :messages="[addTagsHint]"
              v-model="tags"
              data-cy="add-modal.name"
              autofocus
              placeholder="Add Tags"
            )
            v-textarea.mt-2(
              label="Description"
              v-model="description"
              rows=6
              no-resize
            )
      v-card-actions
        v-spacer
        v-btn(data-cy="add-modal.cancel" flat @click="closeDialog(false)") Cancel
        v-btn.primary(v-if="isUpdate" data-cy="add-modal.update" @click="updatePublishedCampaign()" :disabled='!formValid') Update
        v-btn.primary(v-else data-cy="add-modal.submit" @click="closeDialog(true)" :disabled='!formValid') Publish
</template>

<script>

import TitleBar from '@/Core/components/TitleBar';

const SHARE_TYPES = {
  PUBLIC: 2,
  PRIVATE: 3,
};

export default {
  components: {
    TitleBar,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    publishedCampaignData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      shareTypeId: null,
      SHARE_TYPES: Object.freeze(SHARE_TYPES),
      valid: false,
      addTagsHint: 'Type in tags such as "Buyer", "Seller", "Expired", or anything else that would make it easy to distinguish what this campaign is for.',
      dropdownPublicTypeItems: [
          {
              text: 'Public (All LionDesk Users)',
              value: SHARE_TYPES.PUBLIC,
          },
          {
              text: 'Private (Create Code)',
              value: SHARE_TYPES.PRIVATE,
          }
      ],
      description: '',
      tags: [],
      accessCode:'', 
    }
  },
  computed: {
    formValid() {
      return this.valid && ((this.shareTypeId === SHARE_TYPES.PRIVATE && this.accessCode) || this.shareTypeId === SHARE_TYPES.PUBLIC);
    },
    isUpdate() {
      return this.publishedCampaignData && this.publishedCampaignData.id;
    },
    getTitle() {
      return this.isUpdate ? 'Edit your Published Campaign' : 'Publish your Campaign';
    },
  },
  watch: {
    publishedCampaignData(value) {
      if (value && value.id) {
        this.shareTypeId = this.publishedCampaignData.requires_access_code ? SHARE_TYPES.PRIVATE : SHARE_TYPES.PUBLIC;
        this.description = this.publishedCampaignData.description;
        this.tags = this.publishedCampaignData.tags ? this.publishedCampaignData.tags.map(tag => { return tag.name }) : [];
        this.accessCode = this.publishedCampaignData.requires_access_code ? this.publishedCampaignData.access_code : '';
      }
    }
  },
  methods: {
    closeDialog(resourceSubmitted = false) {
      if (!resourceSubmitted) {
        this.$emit('close', false);
      } else {
        const data = {
            "published_campaign_access_type_id": this.shareTypeId,
            "description": this.description,
            "tags": this.tags,
        }
        if (this.shareTypeId === SHARE_TYPES.PRIVATE) {
          data["access_code"] = this.accessCode;
        }
        this.$emit('close', resourceSubmitted, data);
      }
      this.cleanInput();
    },
    updatePublishedCampaign() {
      const data = {
            "id": this.publishedCampaignData.id,
            "campaign_id": this.publishedCampaignData.campaign.id,
            "published_campaign_access_type_id": this.shareTypeId,
            "description": this.description,
            "tags": this.tags,
      }
      if (this.shareTypeId === SHARE_TYPES.PRIVATE) {
        data["access_code"] = this.accessCode;
      }
      this.$emit('on-edit', data);
    },
    cleanInput() {
      this.accessCode = '';
      this.tags = [];
      this.shareTypeId = null;
      this.description = '';
    }
  },
};

</script>
